import React from 'react';
import GovLetterPage from './GovLetterPage';

// new cars, not yet in the fleet: they come only from an Excel of their details
const PAGE = {
    storageKey: 'YELO_REGISTRATION_DATA',
    title: 'Registration (تسجيل مركبات)',
    detailsTitle: 'Registration Details',
    form: {
        title: 'تسجيل مركبات',
        toAddress: 'السادة هيئة الطرق والمواصلات                المحترمين',
        toCity: 'دبي -الامارات العربية المتحدة',
        introStatic: 'نحن شركه الوفاق السعودية التأجير السيارات ذ.م.م  لا مانع لدينا من تسجيل المركبة المدرج أوصافها أدناه تحت اسم الشركة     ',
        introDynamic: '',
    },
    fields: [
        { key: 'date', label: 'Date', rtl: false },
        { key: 'title', label: 'Document Title' },
        { key: 'introDynamic', label: 'Intro Details (Person/Entity)', full: true, rows: 3, placeholder: '[ادخل تفاصيل إضافية هنا]' },
    ],
    pdfName: 'Vehicle_Registration_',
    pageId: 'reg-page-',
    letter: {
        intro: (f) => <>{f.introStatic} {f.introDynamic}</>,
        rows: (car) => [
            { label: 'صنف المركبة', value: car.make_model },
            { label: 'الموديـــــل', value: car.year },
            { label: 'رقم الشاصي', value: car.vin },
            { label: 'اللـــــــــون', value: car.color }
        ],
    },
    upload: {
        description: 'Please upload an Excel file with cars details',
        accept: '.xlsx, .xls',
        template: ['صنف المركبة', 'الموديل', 'رقم الشاصي', 'اللون'],
        templateName: 'Registration_Template.xlsx',
        // Map Excel columns to our car object
        // Required columns: صنف المركبة, الموديل, رقم الشاصي, اللون
        parse: (row, index) => ({
            id: `upload-${index}`,
            make_model: row['صنف المركبة'] || row['Make/Model'] || '',
            year: row['الموديل'] || row['Year'] || '',
            vin: row['رقم الشاصي'] || row['VIN'] || '',
            color: row['اللون'] || row['Color'] || '',
            plate_number: 'N/A (New)'
        }),
        confirm: {
            title: 'Clear List',
            message: 'Are you sure you want to remove all uploaded vehicles?',
            startLabel: 'Clear All',
        },
        selectedCard: (selectedCars) => ({
            title: `Uploaded Vehicles (${selectedCars.length})`,
            itemKey: (car) => car.id,
            removeKey: (car) => car.id,
            primary: (car) => car.make_model,
            secondary: (car) => car.vin,
            tile: () => 'New',
            emptyTitle: 'No vehicles uploaded yet',
            emptyDescription: 'Download the template, fill it in and upload it here.',
        }),
    },
};

const Registration = (props) => <GovLetterPage page={PAGE} {...props} />;

export default Registration;
